import { Metadata } from "../../common-shared-module/model/dyn-form/form-metadata/metadata.model";


export class MetadataChange {
    changed: Metadata[] = []
    deleted: Metadata[] = []

    pushChanged(m: Metadata): MetadataChange {
        this.changed.push(m)
        return this
    }

    pushDelete(m: Metadata): MetadataChange {
        this.deleted.push(m)
        return this
    }

}